<template>
  <transition name="fade">
    <div class="container">
      <div class="center">
        <lottie
          :options="defaultOptions"
          :height="96"
          :width="96"
          v-on:animCreated="handleAnimation"
          :textsWait="textsWait"
        />
        <p class="status-loading" v-if="textArray">{{ textArray }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
import loader from "@/config/constants/loader";
import Lottie from "vue-lottie";
export default {
  name: "LottieLoader",
  components: {
    lottie: Lottie
  },
  props: {
    textsWait: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    if (this.textsWait.length > 0) {
      this.handleWaitText();
    }
    document.getElementsByTagName("html")[0].classList.add("lock-scroll");
  },
  destroyed() {
    document.getElementsByTagName("html")[0].classList.remove("lock-scroll");
  },
  data() {
    return {
      defaultOptions: { animationData: loader },
      animationSpeed: 1,
      textArray: null
    };
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
    },
    handleWaitText() {
      let timer = 1000;
      let array = this.textsWait;
      for (const text of array) {
        setTimeout(() => (this.textArray = text), timer);
        timer += 7000;
      }
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
div.container {
  position: fixed;
  display: table;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  /* background: #043263; */
  background: rgba(255, 255, 255, 0.8);
  z-index: 10000;
}

div.center {
  display: table-cell;
  vertical-align: middle;
}

.status-loading {
  font-size: 1em;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
}
</style>
